import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactswiperService {

  constructor(private httpService: HttpClient) { }

  getContactImages(){
    return this.httpService.get('../../assets/json/contact/contact_swiper.json');
  }
}
